var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"fa fa-chevron-left fa-2x arrow-left",style:({top: _vm.topStyle, left: _vm.leftStyle }),on:{"click":_vm.left}}),_c('span',{staticClass:"fa fa-chevron-right fa-2x arrow-right",style:({top: _vm.topStyle }),on:{"click":_vm.right}})])
}
var staticRenderFns = []

export { render, staticRenderFns }